module.exports = __webpack_public_path__ + "img/leads.602eb637.svg";